import React from "react";
import Card from "../Common/Card";
import teacher from "../../assets/teacher-icon.png";
import report from "../../assets/report-icon.png";
import test from "../../assets/test-icon.png";
import doubt from "../../assets/doubt-icon.png";
import science from "../../assets/science-icon.png";
import ac from "../../assets/ac-icon.png";

export default function Services() {
  const data = [
    {
      src: teacher,
      text: " Our teachers are highly qualified and experienced in their respective fields, ensuring that students receive top-quality education",
      key: "teacher",
      title: "Expert Teachers",
    },
    {
      src: test,
      text: "We believe in regular assessment to track student progress, and conduct weekly tests to help students improve their understanding and performance",
      key: "test",
      title: "Weekly Tests",
    },
    {
      src: doubt,
      text: "We provide dedicated doubt-solving sessions to help students clarify any concepts or topics that they may find challenging",
      key: "doubt",
      title: "Doubt Sessions",
    },
    {
      src: report,
      text: "We provide students and parents with regular performance reports, giving them a clear understanding of the student's progress and areas that need improvement",
      key: "report",
      title: "Online Performance Report",
    },
    {
      src: science,
      text: "Our teaching methodology focuses on practical and interactive ways of learning, helping students understand and retain concepts more effectively",
      key: "science",
      title: "Practical Ways of Learning",
    },
    {
      src: ac,
      text: "Our classrooms are equipped with air conditioning, creating a comfortable and conducive environment for students to learn and focus",
      key: "ac",
      title: "AC Classrooms",
    },
  ];
  return (
    <div className="container my-5">
      <div className="row align-items-center">
        <div className="col-md-4 col-sm-12">
          <h4 className="orange-text text-left mt-5 fw-bold">Services</h4>
          <h1 className="mt-1 head-text">What we Provide to you</h1>
          <p className="p-1 my-4">
            At OOKlass, we believe that every student has the potential to
            achieve great things. That's why we're committed to providing
            personalized education that helps students discover their strengths
            and reach their goals.We offer a learning experience that is
            tailored to each student's unique needs and learning style. Our
            modern facilities, equipped with state-of-the-art technology, create
            a comfortable and conducive learning environment. Join us and
            discover your true potential today!
          </p>
        </div>
        <div className="col-md-8 col-sm-12">
          <div className="row">
            {data.map((ele) => {
              return (
                <div className="col-md-4 col-sm-12" key={ele?.key}>
                  {<Card src={ele.src} text={ele.text} title={ele.title}/>}
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
}
